import { useState } from 'react';

export const useHighlightList = <T>(suggestions: T[]) => {
    const [active, setActive] = useState(0);

    const reset = (): void => {
        setActive(0);
    };

    const highlightNext = (): void => {
        if (active < suggestions.length) {
            setActive(active + 1);
        }
    };

    const highlightPrevious = (): void => {
        if (active > 0) {
            setActive(active - 1);
        }
    };

    return {
        hightlighted: active,
        highlightNext,
        highlightPrevious,
        reset,
    };
};
